// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1732068097237
      var cssReload = require("D:/project/huixin/云商/V12_saas版/erp-flexible-web21-cloud-saas/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  